<template>
	<HeaderWrapper>
		<HeaderText
			:selected-plan-option="selectedPlanOption"
			isWalkIn
		/>
	</HeaderWrapper>
</template>

<script setup lang="ts">
import type { PlanData, PlanOption } from '@/types'
import HeaderText from '@/views/NewSession/PlanVersions/HeaderText.vue'
import HeaderWrapper from '@/views/NewSession/PlanVersions/HeaderWrapper.vue'
import {
	formatLastUpdated,
	getPlanFullName,
} from '@/views/NewSession/PlanVersions/utils'
import { computed, type PropType } from 'vue'

const props = defineProps({
	plan: {
		type: Object as PropType<Partial<PlanData>>,
		required: true,
	},
})

const selectedPlanOption = computed<PlanOption>(() => {
	return {
		id: props.plan?.id!,
		fullName: getPlanFullName(props.plan),
		lastUpdated: props.plan?.lastUpdated,
		formattedDate: formatLastUpdated(props.plan?.lastUpdated),
		source: 'local',
		funeralHomeId: props.plan?.funeralHomeId ?? '',
	}
})
</script>
